module.exports = __webpack_public_path__ + "img/wechatCode.3262fbc1.jpg";